import { getUserId } from '../../../utils/User';

export const filterNodes = rawNodes => {
  try {
    return rawNodes?.filter(node => {
      const userId = getUserId();
      let behaviour = node?.app_behaviour || '{}';
      behaviour = JSON.parse(behaviour);
      let show = true;
      // filtrar por appBehaviour show node
      if (!behaviour?.node_config?.show_node) {
        show = false;
      }
      // filtrar por appBehaviour vis
      if (behaviour?.node_config?.vis) {
        if (userId && 'loggedin' in behaviour?.node_config?.vis) {
          show = behaviour?.node_config?.vis?.loggedin === 1;
          return show;
        }
        if (!userId && 'anon' in behaviour?.node_config?.vis) {
          show = behaviour?.node_config?.vis?.anon === 1;
          return show;
        }
      }
      return show;
    });
  } catch (error) {
    console.warn(error);
    return [];
  }
};
